/* 请求接口地址管理 */
export var IP =
  process.env.NODE_ENV === "development"
    ? "/proxy-server" //本地代理
    : "https://bojun-api.shanghaibojun.cn";

// export var IP = "https://bojun-api.shanghaibojun.cn";     //测试


// export var IP = "https://mall-api.shanghaibojun.cn";     //暂时https停用，正式版再用
